import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Sınıf birleştirici (shadcn'in standart yardımcısı).
 * clsx koşullu sınıfları çözer, twMerge çakışan Tailwind sınıflarından
 * sonuncuyu kazandırır (örn. "px-2 px-4" → "px-4").
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
